import { Client_Event_Name } from '@quiz-buzz/common'
import {page_header_style, Standard_Page_Layout, sub_header_style } from '../Components/Standard_Page_Layout'
import {PayPalScriptProvider, PayPalButtons} from '@paypal/react-paypal-js'
import {get_environment} from '@quiz-buzz/client-common/src/Config/Client_Environments'
import {ChangeEvent, useRef, useState} from 'react'
import { Button } from '../Components/Button'
import { host_machine_actor } from '../App/main'
import { useSelector } from '@xstate/react'

// This doesn't seem to be exported properly by the paypal lib, so copy pasting it here
type OnApproveData = {
	billingToken?: string | null
	facilitatorAccessToken?: string
	orderID: string
	payerID?: string | null
	paymentID?: string | null
	subscriptionID?: string | null
	authCode?: string | null
}

async function create_order(
	quantity: number,
	unit_price_in_cents: number,
	host_email: string,
	host_secret: string,
): Promise<string> {
	return fetch('/api/v1/paypal/create-order', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		// use the "body" param to optionally pass additional order information
		// like product ids and quantities
		body: JSON.stringify({
			cart: [
				{
					sku: '1',
					unit_price_in_cents,
					quantity,
				},
			],
			host_email,
			host_secret,
		}),
	})
		.then(response => response.json())
		.then(order => {
			// Your code here after create the order
			return order.id
		})
}

export function Host_Purchase_Games() {

	const {
		host_email,
		host_secret,
		game_code
	} = useSelector(host_machine_actor, (state) => state.context )


	const send_cancel_game = () => host_machine_actor.send({type: Client_Event_Name.cancel_purchase})

	const unit_price_in_cents = 30

	const [quantity, set_quantity] = useState(1)

	const numRef = useRef<number>() // will be same object each render

	const format_into_currency_string = (cost_in_cents: number) => {
		const num_string = (cost_in_cents / 100).toFixed(2)
		return '$' + num_string
	}

	console.log('render with quantity: ', quantity)

	const change_quantity = (event: ChangeEvent) => {
		const q = parseInt((event.target as HTMLInputElement).value)
		if (!isNaN(q) && q > 0 && q < 500) {
			numRef.current = q // assign new num value each render
			set_quantity(q)
		}
	}

	const dummy_payment_purchase = async () => {

		const autotest_email_input_field = document.getElementById('autotest-create-game-email') as HTMLInputElement
		const autotest_email_string = autotest_email_input_field.value

		return fetch('/api/v1/paypal/autotest-create-order', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				autotest_email_string,
				orderID: "autotest-1",
				host_email: host_secret,
				host_secret: host_secret,
				game_code: game_code
			}),
		})
		.then(response => response.json())
		.then(orderData => {
			// then init the host with the details from the server:
			host_machine_actor.send({ type: Client_Event_Name.start_host_registration })
			console.log('sending order data: ', orderData)
			host_machine_actor.send(orderData)
		})
	}

	function on_approve(data: OnApproveData) {
		return fetch('/api/v1/paypal/capture-order', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				orderID: data.orderID,
				host_email: host_email,
				host_secret: host_secret,
				game_code: game_code
			}),
		})
			.then(response => response.json())
			.then(orderData => {
				// then init the host with the details from the server:
				host_machine_actor.send({ type: Client_Event_Name.start_host_registration })
				console.log('sending order data: ', orderData)
				host_machine_actor.send(orderData)
			})
	}

	const header = (
		<>
			<div className={page_header_style}>Purchase games</div>
			<div className={sub_header_style}>buy some, quick, they're cheap!</div>
		</>
	)
	const content = (
		<>
			<div>Games cost {unit_price_in_cents} cents each</div>
			<input placeholder="quantity" onChange={change_quantity} defaultValue={1}/>
			<div data-testId="games-cost-field">
				Cost: {format_into_currency_string(quantity * unit_price_in_cents)}
			</div>
			<PayPalScriptProvider
				options={{
					clientId: get_environment().paypal_client_id,
					currency: 'AUD',
				}}>
			
				<PayPalButtons
					style={{layout: 'horizontal', label: 'buynow', tagline: false, color: 'blue'}}
					createOrder={() =>
						create_order(
							numRef.current || 1,
							unit_price_in_cents,
							host_email,
							host_secret,
						)
					}
					onApprove={on_approve}
				/>
			
			</PayPalScriptProvider>
			<h2>Notes:</h2>
			<ul>
				<li>You can set up now and the start the game later</li>
				<li>Access your game later with your email address</li>
				<li>No time limits or restrictions</li>
				<li>Access on any device, mobile and/or laptop</li>
			</ul>
			<div style={{opacity: 0}}>
				<input data-testid="autotest-create-game-email" id="autotest-create-game-email" />
				<button onClick={dummy_payment_purchase}>Autotest create game</button>
			</div>
		</>
	)

	const controls = (
		<div className="two_buttons">
			<Button text="Cancel purchase" onClick={send_cancel_game} />
				
			
		</div>
	)
	return (
		<Standard_Page_Layout
			header={header}
			content={content}
			controls={controls}
		/>
	)
}
